module.exports = __webpack_public_path__ + "media/images/btn_icon_header_registration-aa60cb958db9cd3a0ef9b99c11ddc3ed.png";